import { j as t } from "../../../../../../../../../../jsx-runtime.BREq8dyb.js";
import { Box as i } from "@mui/joy";
import { memo as p } from "react";
import "../../../../../../../../contexts/DatasetContext/DatasetContext.js";
import "../../../../../../../../contexts/FeatureContext/FeatureContext.js";
import "../../../../../../../../contexts/FileContext/FileContext.js";
import "../../../../../../../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../../../../../../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as s } from "../../../../../../../../contexts/OptionsContext/OptionsContext.js";
import "../../../../../../../../contexts/SchemaContext/SchemaContext.js";
import "../../../../../../../../contexts/TypificationContext/TypificationContext.js";
import "../../../../../../../../contexts/WorkerContext/WorkerContext.js";
import { ShowRows as l } from "../../../../../../../../types/index.js";
import m from "./components/Indicator/Indicator.js";
const n = p(({
  numErrorsTotal: o,
  numModificationsTotal: r
}) => {
  const {
    showRows: e
  } = s();
  return (o || 0) > 0 || (r || 0) > 0 ? /* @__PURE__ */ t.jsxs(i, { sx: {
    alignItems: "center",
    display: "flex",
    fontSize: "0.75rem",
    gap: "0.5rem",
    lineHeight: "1.25rem"
  }, children: [
    r ? /* @__PURE__ */ t.jsx(m, { color: "neutral.500", value: r }) : null,
    o ? /* @__PURE__ */ t.jsx(m, { color: "danger.500", sx: {
      opacity: e === l.Valid ? 0.25 : 1
    }, value: o }) : null
  ] }) : null;
});
n.displayName = "Indicators";
export {
  n as default
};
//# sourceMappingURL=Indicators.js.map
